"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterEdgesByEdgeAttributes = exports.getEdgeFilterFnsFromFilterGroups = void 0;
const lambda_1 = require("../../lambda");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && true);
/** Supports testing an edge by it's edge attributes
 * Complicated by the fact that sometimes edge attributes not being present should result in a pass
 * */
const predicateToEdgeAttributeTestFn = {
    [iotv_v3_types_1.ComparisonType.EQUALS]: (key, value) => (edgeAttr) => edgeAttr && edgeAttr[key] === value,
    [iotv_v3_types_1.ComparisonType.NOT_EQUALS]: (key, value) => (edgeAttr) => !edgeAttr || edgeAttr[key] !== value, // Controversial, but I think its best if not equals does not assume existence since we can specify existance as well
    [iotv_v3_types_1.ExpressionFunctionType.CONTAINS]: (key, value) => (edgeAttr) => edgeAttr && edgeAttr[key]?.toString().includes(value),
    [iotv_v3_types_1.ExpressionFunctionType.NOT_CONTAINS]: (key, value) => (edgeAttr) => edgeAttr && !edgeAttr[key]?.toString().includes(value),
    [iotv_v3_types_1.ExpressionFunctionType.EXISTS]: (key, value) => (edgeAttr) => edgeAttr && !!edgeAttr[key],
    [iotv_v3_types_1.ExpressionFunctionType.NOT_EXISTS]: (key, value) => (edgeAttr) => !edgeAttr || !edgeAttr[key],
    [iotv_v3_types_1.ExpressionFunctionType.BEGINS_WITH]: (key, value) => (edgeAttr) => edgeAttr && edgeAttr[key]?.toString().startsWith(value),
    [iotv_v3_types_1.ExpressionFunctionType.NOT_BEGINS_WITH]: (key, value) => (edgeAttr) => !edgeAttr || !edgeAttr[key]?.toString().startsWith(value), // Same as NOT_EQUALS above
    [iotv_v3_types_1.ComparisonType.LESS_THAN]: (key, value) => (edgeAttr) => edgeAttr && edgeAttr[key] < value,
    [iotv_v3_types_1.ComparisonType.LESS_EQUAL]: (key, value) => (edgeAttr) => edgeAttr && edgeAttr[key] <= value,
    [iotv_v3_types_1.ComparisonType.GREATER_THAN]: (key, value) => (edgeAttr) => edgeAttr && edgeAttr[key] > value,
    [iotv_v3_types_1.ComparisonType.GREATER_EQUAL]: (key, value) => (edgeAttr) => edgeAttr && edgeAttr[key] >= value,
};
const getEdgeFilterFnFromFilterPartType = (filterPartType) => {
    const filterFn = (edge) => {
        let pass = false;
        const filterFn = predicateToEdgeAttributeTestFn[filterPartType.predicate];
        /** To support dot notation (!) instead pass key accessed value from key splitting logic. As this changes predicateToTestFn, perhaps that logic goes there, or change all the function just to accept value from dot noted atts  */
        pass = filterFn(filterPartType.key, filterPartType.value)(edge.edgeAttributes);
        return pass;
    };
    return filterFn;
};
const getEdgeFilterFnsFromFilterGroups = (filterGroups) => {
    // Get Filter Fns - one fn per filter group
    const filterFns = filterGroups.map((filterGroup) => {
        const subFilters = filterGroup.filters.map((filter) => getEdgeFilterFnFromFilterPartType(filter));
        debug && console.log('Subfilters', subFilters);
        let filterFn = (item) => true;
        if (filterGroup.setOperation === iotv_v3_types_1.LogicalOperatorType.AND) {
            filterFn = (edge) => subFilters.every((subFilter) => subFilter(edge));
        }
        else {
            filterFn = (edge) => subFilters.some((subFilter) => subFilter(edge));
        }
        return filterFn;
    });
    return filterFns;
};
exports.getEdgeFilterFnsFromFilterGroups = getEdgeFilterFnsFromFilterGroups;
const filterEdgesByEdgeAttributes = ({ edges, edgeAttributeFilters, groupSetOperation = iotv_v3_types_1.LogicalOperatorType.AND }) => {
    const edgeAttrFilterFns = (0, exports.getEdgeFilterFnsFromFilterGroups)(edgeAttributeFilters);
    debug && console.log('Edge Attr Filter Fns', edgeAttrFilterFns);
    let filteredEdges = [];
    if (groupSetOperation === iotv_v3_types_1.LogicalOperatorType.AND) {
        // apply each filter the the filtered result of last filter (AND)
        filteredEdges = edgeAttrFilterFns.reduce((a, c) => a.filter(c), edges);
    }
    else {
        const noFilters = edgeAttrFilterFns.length === 0;
        filteredEdges = edges.reduce((a, c) => {
            // 2025 06 pass every node through every filter and if passes some add to result (OR), potentially
            if (noFilters || edgeAttrFilterFns.some((fn) => fn(c))) {
                a.push(c);
            }
            return a;
        }, []);
    }
    return filteredEdges;
};
exports.filterEdgesByEdgeAttributes = filterEdgesByEdgeAttributes;
